import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DialogRichTextComponent } from '@features/dialog/dialog-rich-text/dialog-rich-text.component';
import { OverlayModule } from '@libs/overlay';
import { SharedModule } from '@shared/shared.module';

import { DialogMinimalComponent } from './dialog-minimal/dialog-minimal.component';
import { DialogSidebarComponent } from './dialog-sidebar/dialog-sidebar.component';
import { DialogComponent } from './dialog/dialog.component';

@NgModule({
    imports: [CommonModule, SharedModule, OverlayModule, DialogComponent, DialogRichTextComponent, DialogMinimalComponent, DialogSidebarComponent],
    exports: [DialogComponent, DialogRichTextComponent, DialogMinimalComponent, DialogSidebarComponent]
})
export class DialogModule {}
